/* 🤖 this file was generated by script */
export const wsolidiconReceipt = {
  name: 'receipt',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M15.24 2H8.76q-1.2-.01-2.01.04c-.56.05-1.08.15-1.57.4a4 4 0 0 0-1.74 1.74c-.25.49-.35 1-.4 1.57q-.05.8-.04 2V21a1 1 0 0 0 1.59.8l2.13-1.54 1.9 1.52a1 1 0 0 0 1.22.03L12 20.24l2.16 1.57a1 1 0 0 0 1.21-.03l1.9-1.52 2.14 1.55A1 1 0 0 0 21 21V7.76q.01-1.2-.04-2.01a4 4 0 0 0-.4-1.57 4 4 0 0 0-1.74-1.74c-.49-.25-1-.35-1.57-.4q-.8-.05-2-.04"/></svg>`,
  iconStyle: 'solid',
};
